import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { v4 as uuid } from "uuid";
import DataAnalyticsService from "../dataAnalyticsService";
import GlobalLoader from "../../../commonfields/GlobalLoader";
import ChatComponent from "../../../components/chat/ChatComponent";
import FileUploadContainers from "../../../components/shared/FileUploadContainers";
import { IConversationModel, KB_NAMES_ENUM, DATA_ANALYSIS_STUDIO_TABS, DOC_AI_MODE_ENUM } from "../../../models/ChatModels";
import { MainContext } from "../../../models/MainContext";
import "../scss/dataAnalytics.scss";
import {
  faArrowDown,
  faCheck,
  faChevronLeft,
  faEdit,
  faPen,
  faPlus,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { readString } from "react-papaparse";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  IIngestKdbInput,
  IKDBProjectInput,
  IUserQueryInput,
} from "../../../models/APIModels";
import ExtractedDataModel from "./ExtractedDataModel";
import { IDropdownOptionsModel } from "../../../models/CommonFields";
import {
  getFromSession,
  removeFromSession,
  setToSession,
  text_convert_lower,
} from "../../../helpers/GenericHelpers";
import { RoutesEnum } from "../../../models/RoutesModel";
import { GraphDisplayType, IGraphModel, ProjectTypeEnum, ThemeTypes } from "../../../models/SharedModel";
import NodesComponent from "../../../components/widgets/NodesComponent";
import FileViewer from "../../../commonfields/FileViewer";
import GraphComponent from "../../../components/widgets/GraphComponent";
import { graph_data } from "../../../data/MoreData";
import { pushToLog } from "../../../helpers/LogHelpers";
import { ILogsModel } from "../../../models/LogsModel";
import { ThemeContext } from "../../../models/ThemeContext";
import ibexDarkFullIcon from "../../../images/darkLeftBarIcons/ibexDarkFullIcon.png";
import ibexLightFullIcon from "../../../images/lightLeftBarIcons/ibexLightFullIcon.png";

import Profile from "../../../components/shared/Profile";
import ExtractedDataFrame from "./ExtractedDataFrame";
import ChatComponent2 from "../../../components/chat/ChatComponent2";
import uploadInformation from "../../../images/UploadInformation.png";


import home from "../../../images/darkLeftBarIcons/home.png";
import documentText from "../../../images/darkLeftBarIcons/document-text.png";
import listCicle from "../../../images/darkLeftBarIcons/list-circle.png";
import chatIcon from "../../../images/darkLeftBarIcons/chatbox.png";

import helpCicle from "../../../images/darkLeftBarIcons/help-circle.png";
import settings from "../../../images/darkLeftBarIcons/settings.png";
import logOut from "../../../images/darkLeftBarIcons/log-out.png";
import configIcon from "../../../images/darkLeftBarIcons/config.png";

import homeLight from "../../../images/lightLeftBarIcons/home.png";
import documentTextLight from "../../../images/lightLeftBarIcons/document-text.png";
import listCicleLight from "../../../images/lightLeftBarIcons/list-circle.png";
import chatIconLight from "../../../images/lightLeftBarIcons/chatbox.png";
import configIconLight from "../../../images/lightLeftBarIcons/config.png";

import homeChecked from "../../../images/CheckedIcons/home.png";
import documentTextChecked from "../../../images/CheckedIcons/document-text.png";
import listCicleChecked from "../../../images/CheckedIcons/list-circle.png";
import chatIconChecked from "../../../images/CheckedIcons/chatbox.png";
import configIconChecked from "../../../images/CheckedIcons/config.png";

import helpCicleLight from "../../../images/lightLeftBarIcons/help-circle.png";
import settingsLight from "../../../images/lightLeftBarIcons/settings.png";
import logOutLight from "../../../images/lightLeftBarIcons/log-out.png";
import Settings from "../../../components/shared/Settings";
import QueiryForm from "../../../components/shared/QueiryForm";
import OutputForm from "../../../components/shared/OutputForm";
import { QUEIRY_MODELS } from "../../../models/QueiryModels";
import RawPdfViewer from "../../../commonfields/RawPdfViewer";
import { ProjectStatus } from "../../../models/ProjectModel";
import documentAIService from "../../document_ai/documentAIService";
import CheckboxField from "../../../commonfields/CheckboxField";
const DataAnalyticsPage = () => {

  const { themeName } = useContext(ThemeContext);

  const images:string[]=
   (themeName === ThemeTypes.DARK_THEME) ?
    [home, documentText, listCicle, chatIcon, helpCicle, settings, logOut, configIcon]
   : [homeLight, documentTextLight,  listCicleLight,  chatIconLight, helpCicleLight, settingsLight, logOutLight, configIconLight]

  const checked = [homeChecked, documentTextChecked, listCicleChecked, chatIconChecked, configIconChecked];



  const service = new DataAnalyticsService();
  const documentService = new documentAIService();

  const { projectName, version } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const projectType = useMemo(
    () => location?.pathname?.split("/")?.[2],
    [location?.pathname]
  );

  // states
  const [loader, setLoader] = useState(false); // global loader
  const [chatLoader, setChatLoader] = useState(false); // component loader for chat loading
  const [mode, setMode] = useState(DOC_AI_MODE_ENUM.SINGLE_DOCUMENT_MODE); // document ai modes

  const [csvUpload, setCsvUpload] = useState<any>(null); // csv upload for chat
  const [ontology, setOntology] = useState<any>(null); // ontlogy text details to be uploaded
  const [extractedData, setExtractedData] = useState<any>([]); // csv upload - extracted columns - mostly string []
  const [extractedModal, setExtractedModal] = useState(false); // extracted data modal
  const [documentFile, setDocumentFile] = useState<any>();

  const [conversationList, setConversationList] = useState<
    IConversationModel[]
  >([]); // chat list
  const [questionsList, setQuestionsList] = useState([]); // suggested questions

  const [extractionSwitch, setExtractionSwitch] = useState(false); // swicth extraction type - default false (for generation modal)
  const [graph, setGraph] = useState<IGraphModel | null>(null);
  const [ontologyModal, setOntologyModal] = useState(false);
  const [plotsModal, setPlotsModal] = useState(false);
  const [processingTabs, setProcessingTabs] = useState(
    DATA_ANALYSIS_STUDIO_TABS.DOCUMENT
  );
  const [queiryList,setQueiryList] =useState<QUEIRY_MODELS[]>([]);

  const userName = getFromSession('user_name');

  const project_main = useMemo(() => {
    const project_main_raw = getFromSession("project_main");
    if (project_main_raw) return JSON.parse(project_main_raw);
    else return "";
  }, []);

  const user_id = getFromSession('user_id')

  // helpers
  const toggleExtractedModal = () => setExtractedModal((prev) => !prev);

  const toggleOntologyModal = () => setOntologyModal((prev) => !prev);

  const togglePlotsModal = () => setPlotsModal((prev) => !prev);

  const clearChat = () => {
    setQuestionsList([]);
    setConversationList([]);
  };

  const clearAll = () => {
    setCsvUpload(null);
    setOntology(null);
    setExtractedData([]);
    clearChat();
  };

  const handleUploadCSV = (files: any) => {
    if (files?.length > 0) {
      setCsvUpload(files);
      setOntology(files);
      const name = `${KB_NAMES_ENUM.KDB_NAME}_${Math.floor(
        100000 + Math.random() * 900000
      )}`;
      setToSession(KB_NAMES_ENUM.KDB_NAME, name);
    } else {
      clearAll();
    }
  };

  useEffect(() => {
    if (csvUpload !== null) {
      extractOntology();
    }
  }, [csvUpload])

  const handleOntology = (files: any) => {
    // if (files?.length > 0) {
    setOntology(files);
    // } else {
    //   clearAll();
    // }
  };

  const displayOntologyModal = () => {
    if (extractionSwitch) {
      return ontology?.length > 0
    } else {
      return graph && graph?.nodes && graph?.nodes?.length > 0
    }
  }

  const extractOntology = () => {
    if (csvUpload && csvUpload?.length > 0) {
      upload_csv(false);
      setLoader(true);
      readString(csvUpload?.[0], {
        worker: true,
        complete: (results) => {
          setExtractedData(results?.data?.[0] || []);
          setLoader(false);
        },
      });
    } else setExtractedData([]);
  };

  const downloadChat = () => {
    const element = document.createElement("a");
    const newData = conversationList?.map(
      (each) =>
        `User: ${each?.prompt?.value
          ?.trimStart()
          ?.trimEnd()}\nResponse: ${each?.answer?.value
            ?.trimStart()
            ?.trimEnd()}\n\n`
    );
    const file = new Blob(newData, { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "chat.txt";
    document.body.appendChild(element);
    element.click();
  };

  // apis

  const ingest_kdb = () => {
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
    const payload = {
      files: ontology,
      project_name: projectName,
      project_type: projectType,
      kdbName,
      version,
    };

    service
      .da_ingest_kdb(payload as IIngestKdbInput)
      .then((res) => {
        const id = uuid();
        setConversationList([
          {
            id,
            prompt: { value: "Hi", time: new Date() },
            answer: {
              value: "Hello! How may I assist you ?",
              time: new Date(),
            },
          },
        ]);
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  const question_answer = async (prompt: string, init = false) => {
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
    setChatLoader(true);
    const id = uuid();
    const new_conversation = init ? [] : conversationList;
    setConversationList([
      ...new_conversation,
      { id, prompt: { value: prompt, time: new Date() } },
    ]);

    const payload = {
      project_name: projectName,
      project_type: projectType,
      query: prompt,
      file_name: csvUpload?.[0]?.path?.split(".")?.[0],
      kdbName,
      version,
      project_id: project_main?.project_id,
    };

    service
      .da_get_networkx_userquery(payload as IUserQueryInput)
      .then((res) => {
        setConversationList((prev) =>
          prev?.map((each) => {
            if (each?.id === id) {
              return {
                ...each,
                answer: {
                  value: res?.data || "Something went wrong",
                  time: new Date(),
                },
              };
            } else return each;
          })
        );
        const logData: ILogsModel = {
          log_id: uuid(),
          project_id: project_main?.project_id,
          username: user_id,
          solution: projectName || '',
          solution_type: projectType as ProjectTypeEnum,
          api: '/da_get_networkx_userquery',
          prompt,
          result: res?.data,
          tags: [],
          violations: [],
          role: 'USER',
          time: new Date(),
        }
        pushToLog(logData)
        setChatLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setChatLoader(false);
      });
  };

  const upload_csv = (ingest = true) => {
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
    setLoader(true);
    const payload = {
      files: csvUpload,
      project_name: projectName,
      project_type: projectType,
      kdbName,
      version,
      project_id: project_main?.project_id,
    };

    service
      .da_upload_csv(payload as IIngestKdbInput)
      .then(() => {
        if (ingest) {
          ingest_kdb();
        } else {
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  const startChat = () => {
    upload_csv();
  };

  const saveExtractedData = (payload: any) => {
    if (payload && payload?.length > 0) {
      const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
      const values = {};
      let edges: any = [];
      payload?.forEach((each: any) => {
        // if (each?.values?.length > 0) {
        //   Object.assign(values, {[each?.label]: {
        //     "samples": [],
        //     "related_columns": each?.values?.map((value: IDropdownOptionsModel) => value?.value)
        //   } })
        // } else {
        //   Object.assign(values, {[each?.label]: {
        //     "samples": [],
        //     "related_columns": [each?.label]
        //   }})
        // }
        if (each?.values?.length > 0) {
          Object.assign(values, {
            [each?.label]:
              each?.values?.map(
                (value: IDropdownOptionsModel) => value?.value
              ) || [],
          });
          each?.values?.forEach(
            (val: any) =>
              (edges = [...edges, { from: each?.label, to: val?.value }])
          );
        } else {
          Object.assign(values, { [each?.label]: [each?.label] });
          edges = [...edges, { from: each?.label, to: each?.label }];
        }
      });

      const keys = Object?.keys(values);

      const headers = {
        project_name: projectName,
        project_type: projectType,
        kdbName,
        version,
        file_name: csvUpload?.[0]?.path?.split(".")?.[0],
        project_id: project_main?.project_id,
      };

      setGraph({
        nodes: keys?.map((each) => ({ id: each, label: each })),
        edges,
      });

      service
        .da_ontology_network_x_ingest_kdb(headers as IUserQueryInput, values)
        .then((res) => {
          if (res?.data?.message) {
            const logData: ILogsModel = {
              log_id: uuid(),
              project_id: project_main?.project_id,
              username: user_id,
              solution: projectName || '',
              solution_type: projectType as ProjectTypeEnum,
              api: '/da_ontology_network_x_ingest_kdb',
              prompt: '',
              result: res?.data?.message,
              tags: [],
              violations: [],
              role: 'USER',
              time: new Date(),
            }
            pushToLog(logData)
            const id = uuid();
            setConversationList([
              {
                id,
                prompt: { value: "Hi", time: new Date() },
                answer: {
                  value: "Hello! How may I assist you ?",
                  time: new Date(),
                },
              },
            ]);
            toast.success(res?.data?.message);
          }
          toggleExtractedModal();
        })
        .catch((err) => console.log(err));
    }
  };

  const getPlots = async (prompt?: string) => {
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);

    const payload = {
      project_name: projectName,
      project_type: projectType,
      query: prompt || 'How many high priority gaps are there in IEP1?',
      file_name: csvUpload?.[0]?.path?.split(".")?.[0],
      kdbName,
      version,
      project_id: project_main?.project_id,
    };

    service
      .da_get_user_query_plots(payload as IUserQueryInput)
      .then((res) => {
        console.log(res?.data)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // useEffects
  useEffect(() => {
    if (csvUpload?.length !== 1) {
      clearChat();
    }
  }, [csvUpload]);

  const [formValues, setFormValues] = useState<any>(
    {
      temparature: 0.1,
      chunk_overlap: 250,
      chunk_size: 250
    })

  const addConfig = (data: any) => {
    const finalData = { ...data, project_id: project_main?.project_id }
    service?.add_project_configuration(finalData).then((response: any) => {
      response?.data && toast.success(response?.data);
      // toggleSettingsModal()
    }).catch((error: any) => {
      console.log(error)
      toast.error('something went wrong')
    })
  }

  const getConfig = (projectId: string) => {
    const data = { project_id: projectId }
    service?.get_project_configuration_details(data).then((res: any) => {
      const resdata = {
        "chunk_overlap": res?.data?.chunk_overlap,
        "chunk_size": res?.data?.chunk_size,
        "model_name": res?.data?.model_name,
        "open_ai_key": res?.data?.open_ai_key,
        "temperature": res?.data?.temperature
      }
      setFormValues(resdata);
    }).catch((error: any) => {
      console.log(error)
    })
  }

  useEffect(() => {
    getConfig(project_main?.project_id)
  }, [project_main?.project_id])

  const ingest_training_data = () =>{
    const payload ={
      project_id:project_main?.project_id,
      data_dict:queiryList
    }
    service?.ingest_training_data(payload).then((response:any)=>{
      
    }).catch((error:any)=>{
      console.log(error)
    })
  }

  const query_with_agent = (queiry:QUEIRY_MODELS) =>{
    const payload ={
      project_id:project_main?.project_id,
      user_input: queiry?.question
    }
    service?.query_with_agent(payload).then((response:any)=>{

    }).catch((error:any)=>{
      console.log(error)
    })
  }

  // ===========================================================
  const [fileType, setFileType] = useState();
  const [isDockUploaded, setIsDockUploaded] = useState(false);

  const resetFields = () => {
    setExtractedData([]);
    setQuestionsList([]);
    setConversationList([]);
  };
  const clearFields = () => {
    setDocumentFile(null);
    resetFields();
    removeFromSession(KB_NAMES_ENUM.KDB_NAME);
  };
  const handleDocumentChange = (e: any) => {
    setFileType(e[0]?.type)
    const name = `${KB_NAMES_ENUM.KDB_NAME}_${Math.floor(
      100000 + Math.random() * 900000
    )}`;
    setToSession(KB_NAMES_ENUM.KDB_NAME, name);
    setDocumentFile(e);
    if (e?.length === 0) {
      clearFields();
      setIsDockUploaded(false);
    }
    else {
     
    }
  };

  const ingest_doc_db = async () => {
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
    const payload = {
      // files: documentFile,
      files: ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded) ? undefined : documentFile,
      file_name: (project_main?.project_status === ProjectStatus.PRODUCTION || ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded)) ? documentFile[0]?.path : undefined,
      project_name: projectName,
      reload: ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded) ? "True" : "False",
      project_type: projectType,
      kdbName,
      version,
      project_id: project_main?.project_id,
    };
    setLoader(true);
    documentService
      .docai_ingest_kdb(payload as IIngestKdbInput, project_main?.project_status)
      .then((res) => {
        // knowledgebase_summarization();
        const id = uuid();
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  useEffect(() => {
    if ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && documentFile && !isDockUploaded) {
      ingest_doc_db();
      // auto_template()
    }
  }, [documentFile?.length > 0])

  const singleView = () =><RawPdfViewer file={documentFile?.[0]} />

  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  const handleCheckboxChange = (values: string[]) => {
    setSelectedOptions(values);
  };

  const [submitted, selectSubmitted] = useState(false);

  const submitSelected = () =>{
    let payload = {      
                    "business_text" : selectedOptions.includes('business_text'),
                    "wiki_text" : selectedOptions.includes('wiki_text'), 
                    "search_text" : selectedOptions.includes('search_text'), 
                    "sql_text" : selectedOptions.includes('sql_text'),       
                    "Pubmed_text" : selectedOptions.includes('Pubmed_text')     
                  } 
     service.save_insight_status(payload).then((response:any)=>{
      console.log(response)
      selectSubmitted(true)
     }).catch((error:any)=>{
        console.log(error)
     })
  }

  const checkValue = () =>{
    if(selectedOptions.includes('business_text') && submitted){
      return false
    }else{
      return true
    }
  }

  const options = [
    { label: 'Business knowledge DB 1', value: 'business_text' },
    { label: 'Wiki agent', value: 'wiki_text' },
    { label: 'Search Engine agent', value: 'search_text' },
    { label: 'Data base Engine', value: 'sql_text' },
    { label: 'Pubmed agent', value: 'Pubmed_text' },
  ];
  return (
    <>
      <div className={`solition-studio ${themeName === ThemeTypes?.BLUE_THEME ? 'bright' : ''}`}>
        <div className='left-menu'>
          <div className='header'>
            <img src={themeName === ThemeTypes?.BLUE_THEME ? ibexLightFullIcon : ibexDarkFullIcon} alt='Ibex' />
          </div>
          <div className='menu'>
            <div className='top-menu'>
              <Nav pills>
                <div className='item home'>
                  <NavItem>
                    <NavLink
                      className={
                        processingTabs === DATA_ANALYSIS_STUDIO_TABS.DASHBOARD
                          ? "active"
                          : ""
                      }
                      // onClick={() => setProcessingTabs(DATA_ANALYSIS_STUDIO_TABS.DASHBOARD)}
                      onClick={() => navigate(`${RoutesEnum.LANDING}`)}
                    >
                      <img src={images[0]} alt="Home" /><div className='text'>Dashboard </div>
                    </NavLink>
                  </NavItem>
                </div>
                <div className='item'>
                  <NavItem>
                    <NavLink
                      className={
                        processingTabs === DATA_ANALYSIS_STUDIO_TABS.DOCUMENT
                          ? "active"
                          : ""
                      }
                      onClick={() => setProcessingTabs(DATA_ANALYSIS_STUDIO_TABS.DOCUMENT)}
                    >
                      <img src={processingTabs === DATA_ANALYSIS_STUDIO_TABS.DOCUMENT ? checked[1] : images[1]} alt="Home" /><div className='text'>Document</div>
                    </NavLink>
                  </NavItem>
                </div>
                <div className='item'>
                  <NavItem>
                    <NavLink
                      className={
                        processingTabs === DATA_ANALYSIS_STUDIO_TABS.ONTOLOGY
                          ? "active"
                          : ""
                      }
                      onClick={() => setProcessingTabs(DATA_ANALYSIS_STUDIO_TABS.ONTOLOGY)}
                    >
                      <img src={processingTabs === DATA_ANALYSIS_STUDIO_TABS.ONTOLOGY ? checked[2] : images[2]} alt="Home" /><div className='text'>Ontology</div>
                    </NavLink>
                  </NavItem>
                </div>
                {/* <div className='item'>
                  <NavItem>
                    <NavLink
                      className={
                        processingTabs === DATA_ANALYSIS_STUDIO_TABS.ONTOLOGY_GRAPH
                          ? "active"
                          : ""
                      }
                      onClick={() => setProcessingTabs(DATA_ANALYSIS_STUDIO_TABS.ONTOLOGY_GRAPH)}
                    >
                      <img src={listCicle} alt="Home" /><div className='text'>Graph</div>
                    </NavLink>
                  </NavItem>
                </div> */}
                <div className='item'>
                  <NavItem>
                    <NavLink
                      className={
                        processingTabs === DATA_ANALYSIS_STUDIO_TABS.CHATBOT
                          ? "active"
                          : ""
                      }
                      onClick={() => setProcessingTabs(DATA_ANALYSIS_STUDIO_TABS.CHATBOT)}
                    >
                      <img src={processingTabs === DATA_ANALYSIS_STUDIO_TABS.CHATBOT ? checked[3] : images[3]} alt="Home" /><div className='text'>ChatAi</div>
                    </NavLink>
                  </NavItem>
                </div>
                <div className='item'>
                    <NavItem>
                      <NavLink
                        className={
                          processingTabs === DATA_ANALYSIS_STUDIO_TABS.TEST_QUERY
                            ? "active"
                            : ""
                        }
                        onClick={() => setProcessingTabs(DATA_ANALYSIS_STUDIO_TABS.TEST_QUERY)}
                      >
                        <img src={processingTabs === DATA_ANALYSIS_STUDIO_TABS.TEST_QUERY ? checked[3] :images[3]} alt="Home" /><div className='text'>Query</div>
                      </NavLink>
                    </NavItem>
                  </div>
                {/* <div className='item'>
                    <NavItem>
                      <NavLink
                        className={
                          processingTabs === DATA_ANALYSIS_STUDIO_TABS.CONFIGURE_PREFERENCES
                            ? "active"
                            : ""
                        }
                        onClick={() => setProcessingTabs(DATA_ANALYSIS_STUDIO_TABS.CONFIGURE_PREFERENCES)}
                      >
                        <img src={processingTabs === DATA_ANALYSIS_STUDIO_TABS.CONFIGURE_PREFERENCES ? checked[4] :images[7]} alt="Home" /><div className='text'>Configure&nbsp;Preferences</div>
                      </NavLink>
                    </NavItem>
                </div> */}
              </Nav>
            </div>
            <div className='footer-menu'>
              <div className='item'><img src={images[4]} alt="Home" /><div className='text'>Help</div></div>
              <div className='item'><img src={images[5]} alt="Home" /><div className='text'>Settings</div></div>
              <div className='item'><img src={images[6]} alt="Home" /><div className='text'>Logout</div></div>
              {/* <div className='item'><img className='iconImg' src={user} alt="Home" /><div className='text'>Username</div></div> */}
              <div className='item'>
                {/* <img className='iconImg' src={user} alt="Home"/> */}
                <Profile />
                <div className='text'>{userName}</div></div>
            </div>
          </div>
        </div>
        <div className='page-body'>
          <div className='project-header'>
            <div>{projectName}</div>
          </div>
          <TabContent activeTab={processingTabs}>
            <TabPane tabId={DATA_ANALYSIS_STUDIO_TABS.CHATBOT} >
              <div className='pane-content'>
                <div className='child child2'>
                  <div className='chat-assist'>
                    <div className='chat-header'><>iBex Chat Assistant</>
                    </div>
                    <ChatComponent2
                      conversationList={conversationList}
                      question_answer={question_answer}
                      questionsList={questionsList}
                      chatLoader={chatLoader}
                      isRecomendationsOptions={true}
                      isAddOptions={false}
                      displayCheck={true}
                      project_main={project_main}
                      setConversationList={setConversationList}
                      dontScroll={false}
                      textAreaDisable={!csvUpload || csvUpload?.length < 1}
                    />
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId={DATA_ANALYSIS_STUDIO_TABS.ONTOLOGY} >
              <div className='pane-content'>
                <div className='child'>
                  <div style={{ padding: '10px' }}>
                    <Button
                      className="kdb-btn create"
                      disabled={!csvUpload || csvUpload?.length < 1}
                      onClick={extractOntology}
                    >
                      Setup Ontology
                    </Button>
                    <div className="ontology-extracted-frame">
                      <ExtractedDataFrame
                        extractedData={extractedData}
                        extractedModal={extractedModal}
                        saveExtractedData={saveExtractedData} />
                    </div>
                  </div>
                </div>
                <div className='child'>
                  <NodesComponent graph={graph} />
                </div>
              </div>
            </TabPane>
            <TabPane tabId={DATA_ANALYSIS_STUDIO_TABS.DOCUMENT}>
              <div className='pane-content'>
              <div className='child'>
              {documentFile!==undefined ?? <div className='header'>Document Viewer</div>}
                    <div className='document-validation dataAnalytics-doc'>
                      {!documentFile && <FileUploadContainers
                        files={documentFile}
                        handleFileChange={handleDocumentChange}
                        btnlabel={
                          <div className='labels'>
                            <img src={uploadInformation} alt="upload" /><div className='text'><u>Click to Upload</u><br></br>or
                              <br></br>drag and drop</div>
                          </div>
                        }
                        displayFilesContent={true}
                        displayInput={!documentFile || documentFile?.length < 1}
                        accept={{
                          "application/pdf": [".pdf"],
                          "image/jpeg": [".jpeg", ".jpg"],
                          "image/png": [".png"],
                        }}
                        maxFiles={
                          mode === DOC_AI_MODE_ENUM.SINGLE_DOCUMENT_MODE ? 1 : 20
                        }
                        // disabled={checkValue()}
                      />}
                      {documentFile ? (
                        <>
                          {singleView()}
                        </>
                      ) : (
                        <div className="not-found">No Document to display</div>
                      )}
                    </div>
              </div>
              <div className='child'>
                <div className="insight-options">
                  <CheckboxField options={options} onChange={handleCheckboxChange}/>
                  <Button disabled={selectedOptions?.length === 0} onClick={()=>submitSelected()}>Submit</Button>
                </div>
              </div>
              </div>
            </TabPane>
            <TabPane tabId={DATA_ANALYSIS_STUDIO_TABS.ONTOLOGY_GRAPH}>
              <div className='pane-content'>
                <div className='child child3'>
                  <NodesComponent graph={graph} />
                </div>
              </div>
            </TabPane>
            <TabPane tabId={DATA_ANALYSIS_STUDIO_TABS.CONFIGURE_PREFERENCES}>
                <div className='pane-content'>
                  <div className='child child3'>
                    <Settings   
                      // toggleSettingsModal={toggleSettingsModal}
                      formValues={formValues}
                      setFormValues={setFormValues}
                      addConfig={addConfig}
                    />
                  </div>
                </div>
            </TabPane>
            <TabPane tabId={DATA_ANALYSIS_STUDIO_TABS.TEST_QUERY}>
                <div className='pane-content'>
                  <div className='child'>
                    <QueiryForm 
                      queiryList={queiryList} 
                      setQueiryList={setQueiryList} 
                      ingestTrainingData={ingest_training_data}
                      queryWithAgent={query_with_agent}
                      />
                  </div>
                  <div className='child'>
                    <OutputForm />
                  </div>
                </div>
              </TabPane>
          </TabContent>
        </div>
      </div>
      {/* ontology-modal */}
      <Modal
        className="project-modal ontology-modal"
        isOpen={ontologyModal}
        fade={false}
        toggle={toggleOntologyModal}
      >
        <ModalHeader toggle={toggleOntologyModal}>
          Ontology {extractionSwitch ? 'File' : 'Graph'}
        </ModalHeader>
        <ModalBody>
          {extractionSwitch ? (
            <FileViewer file={ontology?.[0]} />
          ) : (
            <NodesComponent graph={graph} />
          )}
        </ModalBody>
      </Modal>

      {/* plots-modal */}
      <Modal
        className="project-modal plots-modal"
        isOpen={plotsModal}
        fade={false}
        toggle={togglePlotsModal}
      >
        <ModalHeader toggle={togglePlotsModal}>Plots</ModalHeader>
        <ModalBody>
          <GraphComponent
            graphData={[
              ...graph_data?.map((each) => ({
                ...each,
                plotId: uuid(),
              })),
            ]}
            displayType={GraphDisplayType.CAROUSEL}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default DataAnalyticsPage;

{/* <div className='pane-content'>
<div className='child child3'>
        <div className='document'>
          <FileUploadContainers
            files={csvUpload}
            handleFileChange={handleUploadCSV}
            label=""
            btnlabel={
              // <>
              //   <FontAwesomeIcon icon={faPlus} /> Add CSV
              // </>
              <div className='labels'>
                <img src={uploadInformation} alt="upload" /><div className='text'><u>Click to Upload</u><br></br>or
                  <br></br>drag and drop</div>
              </div>
            }
            maxFiles={1}
            displayFilesContent={true}
            displayInput={!csvUpload || csvUpload?.length < 1}
            accept={{
              "text/csv": [".csv"],
            }}
          />
          {csvUpload ? (
            <>
              
              <FileViewer file={csvUpload?.[0]} showPreview={true} />
            </>
          ) : (
            <div className="not-found">No Document to display</div>
          )}
        </div>
</div>
</div> */}
